export default __webpack_public_path__ + "static/media/Nine.a8af71ca.svg";